import { Tooltip } from "@mantine/core";

import type { PropsWithTableInfo } from "@/types/third-party";
import type { Maybe } from "@/types/utils";
import { truncateString } from "@/utils/helpers";

export type TextCellValue = Maybe<string | number>;

export const TextCell = <TData,>({
  info,
}: PropsWithTableInfo<TData, TextCellValue>) => {
  const value = info.getValue();
  const stringValue = value ? String(value) : "";

  return stringValue.length > 50 ? (
    <Tooltip
      label={info.getValue()}
      withArrow
      arrowSize={8}
      c="black"
      color="white"
      w={400}
      className="border border-gray-200 z-[1000]"
    >
      <span className="truncate">{truncateString(stringValue, 50)}</span>
    </Tooltip>
  ) : (
    stringValue || "—"
  );
};
